export default {
  profileOptionsLoading: false,
  basicProfileData: {
    full_name: null,
    email: null,
    phone_number: null,
    title: null,
    location: null,
    industry: null,
    job_title: null,
    summary: null,
    gender: null,
    nationality: null,
    month_salary: null,
    birth_date: null,
    local_currency: null
  },
  basicProfileDataErrors: {
    full_name: null,
    title: null,
    location: null,
    industry: null,
    job_title: null,
    month_salary: null
  },
  profileOptions: {},
  jobTitlesOptions: [],
  jobTitlesOptionsLoading: false
};
